import { Accordion, List, Stack, Title } from "@mantine/core";
import { useEffect } from "react";




const FAQ: React.FC = () => {
    useEffect(() => {
        document.title = "FAQ - Guard Dog Real Estate Protection Service";
    }, []);
    return (
        <>
            <Title order={1} c='pq-red' style={{ fontFamily: 'Elston, sans-serif', letterSpacing: '2px' }}>Guard Dog&trade; Real Estate Protection Service FAQ</Title>
            <Accordion variant='separated'>
                <Accordion.Item key={0} value="0">
                    <Accordion.Control bg='pq-light-gray'>What information should I enroll?</Accordion.Control>
                    <Accordion.Panel>
                        <Stack>
                            <List spacing={'lg'}>
                                <List.Item>Enroll the Assessor Parcel Number (APN) for the property you wish to guard. If you do not know the property's APN, search for the property by address. As you enter the desired address, a list of matching addresses and their corresponding APN will be shown to you from the assessor's tax roll. Once you find the desired property click the "Guard Property" button to add that APN to your list of guarded items.</List.Item>
                                <List.Item>Enroll a property owner Name. You may enroll the name of an individual, business, or trust. As you type the desired name, a list of matching names will be shown to you from the assessor's tax roll. You may choose to guard one of the suggested entries or guard the name exactly as you have typed it.</List.Item>
                                <List.Item>Enroll other names that are most relevant or important to you that you wish to guard. Enter the custom name you wish to guard and click "Guard Name" next to the Custom Name entry that appears above the list of assessor's tax roll matches (if any).</List.Item>
                                <List.Item>Reminder: You can register 10 names and/or 10 Assessor Parcel Number(s) (APNs) per registered email. Please be aware that you will receive notifications for any names that match those registered.</List.Item>
                            </List>
                            {/* <Text>Enroll a name most relevant or important to you that you wish to guard. If your property title is held individually, in a trust, or under a business name, you can register using any of those names. Reminder: you can register 10 names and/or 10 Assessor Parcel Number(s) (APNs) per registered email. Please be aware that you will receive notifications for any names that match those registered.</Text>
                            <Title order={3}>EXAMPLES OF CORRECT NAME FORMATS</Title>
                            <Title order={4} td="underline">Individual Names</Title>
                            <Text fs='italic'>Example: George Andrew Washington Jr.</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Washington, George Andrew Jr</List.Item>
                                <List.Item>Washington, George A Jr</List.Item>
                                <List.Item>Washington, George A</List.Item>
                                <List.Item>Washington, George Jr</List.Item>
                                <List.Item>Washington, George</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    George, Washington
                                </List.Item>
                            </List>
                            <Text fs='italic'>Prefixes on surnames example: Jose La Posda</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>La Posda, Jose</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Jose, La Posda
                                </List.Item>
                            </List>
                            <Text fs='italic'>Prefixes on surnames example: George St. John</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>St John, George</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    George, St John
                                </List.Item>
                            </List>
                            <Text fs='italic'>Prefixes on surnames example: Molly O'Hare Smith</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Smith, Molly O Hare</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Molly O Hare, Smith
                                </List.Item>
                            </List>
                            <Text fs='italic'>Prefixes on surnames example: Walter Van de Kamp</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Van de Kamp, Walter</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Walter, Van de Kamp
                                </List.Item>
                            </List>
                            <Title order={4} td="underline">Business/Other Names</Title>
                            <Text fs='italic'>Corporation Example: The Generic Business Inc</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Generic Business Inc</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Generic Business, Inc
                                </List.Item>
                            </List>
                            <Text fs='italic'>Limited Liability Example:  The Generic Business LLC</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Generic Business LLC</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Generic Business, LLC
                                </List.Item>
                            </List>
                            <Text fs='italic'>Trusts Example: The Johnson Family Trust</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Johnson Family Trust</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Johnson Family Trust, The
                                </List.Item>
                            </List>
                            <Text fs='italic'>Trusts Example: The Johnson Family Trust Agreement</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Johnson Family Trust</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Johnson Family Trust Agreement, The
                                </List.Item>
                            </List>
                            <Text fs='italic'>Trusts Example: The Gary Myers and Jane Myers Trust</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>Gary Myers and Jane Myers Trust</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    Gary Myers and Jane Myers Trust, The
                                </List.Item>
                            </List>
                            <Title order={4} td="underline">APN - Assessor Parcel Numbers</Title>
                            <Text fs='italic'>APN Example: 123-456-78-90</Text>
                            <List spacing='sm' size='md'
                                icon={<ThemeIcon color="teal" size={24} radius="xl">
                                    <IconCircleCheck size={16} />
                                </ThemeIcon>}>
                                <List.Item>123-456-78-90</List.Item>
                                <List.Item icon={
                                    <ThemeIcon color="red" size={24} radius="xl">
                                        <IconX size={16} />
                                    </ThemeIcon>
                                }>
                                    1234567890 (no dashes)
                                </List.Item>
                                <Text fs='italic' mt={5}>See the APN format provided when you select a County from the dropdown</Text>
                            </List> */}
                        </Stack>
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={1} value="1">
                    <Accordion.Control bg='pq-light-gray'>After I subscribe, which documents will I receive notification about?</Accordion.Control>
                    <Accordion.Panel>After you subscribe, Guard Dog will alert you to newly recorded official record documents once the document has been indexed into the Grantor/Grantee Index.</Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={2} value="2">
                    <Accordion.Control bg='pq-light-gray'>Will I receive an alert for documents that were recorded in the past?</Accordion.Control>
                    <Accordion.Panel>No, Guard Dog only alerts you to documents recorded after the subscriber's registration has been activated.</Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={3} value="3">
                    <Accordion.Control bg='pq-light-gray'>Will Guard Dog also provide a copy of the recorded document?</Accordion.Control>
                    <Accordion.Panel>
                        The email notification will provide you with an image of the first two (2) pages of the recorded document and a document number for the indexed name and/or APN you registered. We will not be able to provide a complete copy of the recorded document or information regarding the contents of the document. You may purchase a copy of the document online using the link provided in the notification email or from the county recorder with whom the document was recorded. 
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={4} value="4">
                    <Accordion.Control bg='pq-light-gray'>After I subscribe, can I edit my information?</Accordion.Control>
                    <Accordion.Panel>
                        Yes, log into your account to view and edit your notification methods or the items being guarded. You can also review any recent alerts that may have been sent to you.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={5} value="5">
                    <Accordion.Control bg='pq-light-gray'>Can I unsubscribe from this service?</Accordion.Control>
                    <Accordion.Panel>
                    Yes, you can unsubscribe at any time. Simply log into your Guard Dog account and delete all items being guarded. You will no longer receive any alert emails from Guard Dog.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={6} value="6">
                    <Accordion.Control bg='pq-light-gray'>What happens if a document gets recorded using a name or APN I registered?</Accordion.Control>
                    <Accordion.Panel>
                        An automated email will be sent to the subscriber email address with an image of the first two (2) pages of the recorded document, the document number for the name and/or APN that was registered, a link which you can use to purchase the full document, and instructions on what to do next if you suspect fraud.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={7} value="7">
                    <Accordion.Control bg='pq-light-gray'>After a document is recorded, at what point is the subscriber notified?</Accordion.Control>
                    <Accordion.Panel>
                        An automated email will be generated once the document has been recorded and indexed into the Grantor/Grantee Index.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={8} value="8">
                    <Accordion.Control bg='pq-light-gray'>Will customers automatically be notified when a document is recorded in their name or APN?</Accordion.Control>
                    <Accordion.Panel>
                        Customers will only receive alerts for the Name(s) and/or APN(s) they have registered to be guarded.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={9} value="9">
                    <Accordion.Control bg='pq-light-gray'>What if I suspect fraud?</Accordion.Control>
                    <Accordion.Panel>
                        If fraud is suspected, immediately follow the instructions in the Recording Alert email sent to you by Guard Dog or contact the recorder's office in the county in which the suspect document was recorded. See the county's website for contact information.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={10} value="10">
                    <Accordion.Control bg='pq-light-gray'>Why do fraudulent documents get recorded?</Accordion.Control>
                    <Accordion.Panel>
                        The State of California requires the Recorder's Office to record all documents that meet recording requirements outlined in California Statute. County Recorders have no authority to refuse to record a document that meets recording requirements based on legal sufficiency.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={11} value="11">
                    <Accordion.Control bg='pq-light-gray'>What can I do to protect myself from property fraud?</Accordion.Control>
                    <Accordion.Panel>
                        <List>
                            <List.Item>You can sign up for Guard Dog to receive email notifications when a document is recorded in a name or APN that you register.</List.Item>
                            <List.Item>You can check the County Recorder's Official Records Index to see what documents are currently recorded in your name.</List.Item>
                            <List.Item>Make sure the County Assessor and Tax Collector Offices have your correct mailing address for any properties you own.</List.Item>
                        </List>
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={12} value="12">
                    <Accordion.Control bg='pq-light-gray'>What does 24/7 monitoring mean? What are you monitoring 24/7?</Accordion.Control>
                    <Accordion.Panel>
                        Guard Dog is accessible to the public 24 hours a day, 7 days a week except during maintenance times. Email notifications may be sent out any time a record is indexed into the Grantor/Grantee Index.<br />
                        <br />
                        Guard Dog is continuously watching for new index information and images from the County Recorder. As soon as data is received it is analyzed for matches between registered names and APNs. When matches are found, Guard Dog immediately alerts account owners of the potentially fraudulent recording, so they have the opportunity to respond quickly.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={13} value="13">
                    <Accordion.Control bg='pq-light-gray'>Can I register a property held in a trust?</Accordion.Control>
                    <Accordion.Panel>
                        Yes, you can register a property held in a trust. Using the "Guard a Name" option you can guard the name of a trust exactly as you enter it or choose to guard the name as it appears on the assessor's tax roll.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={14} value="14">
                    <Accordion.Control bg='pq-light-gray'>What information do I need to register a property held in a trust?</Accordion.Control>
                    <Accordion.Panel>
                        You will need the name of the trust, the name(s) of the trustees, and the APN (optional).
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={15} value="15">
                    <Accordion.Control bg='pq-light-gray'>What should I do if the trust name or trustee information changes?</Accordion.Control>
                    <Accordion.Panel>
                        If there are any changes to the trust name or trustee information, update the registration details as soon as possible to ensure accurate and effective guarding.
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key={16} value="16">
                    <Accordion.Control bg='pq-light-gray'>Can multiple trustees receive notifications for the same property?</Accordion.Control>
                    <Accordion.Panel>
                        Yes, multiple trustees can register separately to receive notifications for the same property/APN.
                    </Accordion.Panel>
                </Accordion.Item>

            </Accordion>
        </>
    );
}

export default FAQ;

